import React from 'react';
import {
  Box,
  Grow,
  makeStyles, Typography,
} from '@material-ui/core';
import { MainteningIcon } from 'src/components/CustomSVG';
import PlainLayout from 'src/layouts/PlainLayout';

const useStyles = makeStyles((theme) => ({
  root:{
    display:"flex",
    flexDirection:"column",
    alignItems:"center",
  },
  label : {
    color:"white",
    fontSize:34,
    fontWeight:600,
    fontFamily:"NotoSanThai"
  }
}));

const MaintenancePage: React.FC = () => {

  const classes = useStyles();
  return (
    <PlainLayout>
      <div className={classes.root}>
        <Typography className={classes.label} align="center">ขออภัย</Typography>
        <Box py={1}/>
        <Typography className={classes.label} align="center">บริการนี้อยู่ในช่วงกำลังปรับปรุง</Typography>
        <Box py={3}/>
        <MainteningIcon/>
      </div>
    </PlainLayout>
  )
}

export default MaintenancePage;
